import React, { Suspense } from "react"
import { Navigate, Outlet, useLocation } from "react-router-dom"
import { useAuthContext } from "contexts/AuthContext"
import {
  UNAUTHENTICATED_ENTRY,
  PROFESSOR_AUTHENTICATED_ENTRY,
} from "configs/AppConfig"
import { USER_TYPES } from "common/constants"
import Loading from "components/Loading"

const ProfessorRoutes = () => {
  const location = useLocation()
  const { userData, isLoading, isConfigurationCompleted } = useAuthContext()

  if (isLoading) {
    return <Loading />
  }

  if (!userData || !userData.userId || userData.userId < 1) {
    return <Navigate to={UNAUTHENTICATED_ENTRY} replace />
  }

  if (!userData.userTypeId || userData.userTypeId !== USER_TYPES.TEACHER) {
    return <Navigate to="/" replace />
  }

  if (
    !isConfigurationCompleted &&
    !location.pathname.startsWith("/professor/account")
  ) {
    return <Navigate to="/professor/account" replace />
  }

  if (location.pathname === "/professor") {
    return (
      <Navigate
        to={
          isConfigurationCompleted
            ? PROFESSOR_AUTHENTICATED_ENTRY
            : "/professor/account"
        }
        replace
      />
    )
  }

  return (
    <Suspense fallback={<Loading />}>
      <Outlet />
    </Suspense>
  )
}

export default ProfessorRoutes
